
export default {
  name: 'OrderRecordDetails',
  props: {
    formData: {
      type: Object,
      required: true
    },
    changeable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    producerLabel () {
      const producer = this.related('contacts', this.formData.producer)
      return producer?.display_name || producer?.full_name || producer?.company || producer?.name || this.fallback(this.formData.producer)
    },
    diversionPointLabel () {
      const diversionPoint = this.related('diversionPoints', this.formData.diversionPoint)
      return diversionPoint?.name || this.fallback(this.formData.diversionPoint)
    }
  },
  methods: {
    related (storeName, value) {
      if (!value) {
        return null
      }
      if (typeof value === 'object') {
        return value
      }
      return this.$store.getters[`${storeName}/find`](value)
    },
    fallback (value) {
      if (!value) {
        return '--'
      }
      if (typeof value === 'object') {
        return value.name || value.display_name || value.full_name || value.id || '--'
      }
      return value
    }
  }
}
